export const SET_NUMBER_OF_PDF = 'SET_NUMBER_OF_PDF'


// WEBPACK FOOTER //
// ./src/redux/pdf/types.js